@tailwind base;
@tailwind components;
@tailwind utilities;

@layer utilities {
  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
}

.grecaptcha-badge {
  visibility: hidden;
}
